const pgcetmbaComputerAwareness = [
  {
    id: 1,
    question: "Which of the following memories is non-volatile and stores the firmware that a computer needs to start up?",
    options: ["A. RAM", "B. Cache memory", "C. ROM", "D. CPU registers"],
    answer: "C"
  },
  {
    id: 2,
    question: "What is the full form of BIOS?",
    options: ["A. Basic Input Output System", "B. Binary Integrated Operating System", "C. Basic Internal Output Software", "D. Built-in Operating System"],
    answer: "A"
  },
  {
    id: 3,
    question: "What is the binary equivalent of the decimal number 45?",
    options: ["A. 101011", "B. 110101", "C. 101101", "D. 100111"],
    answer: "C"
  },
  {
    id: 4,
    question: "In MS Excel, which function counts the number of cells in a range that contain numbers?",
    options: ["A. SUM", "B. COUNTA", "C. COUNTIF", "D. COUNT"],
    answer: "D"
  },
  {
    id: 5,
    question: "Which keyboard shortcut is used to undo the last action in MS Word?",
    options: ["A. Ctrl + Y", "B. Ctrl + Z", "C. Ctrl + X", "D. Ctrl + U"],
    answer: "B"
  },
  {
    id: 6,
    question: "In an e-mail, the \"Bcc\" field is used to:",
    options: [
      "A. Send a copy to recipients whose addresses are hidden from the other recipients",
      "B. Attach large files to the message",
      "C. Mark the message as high priority",
      "D. Encrypt the contents of the message"
    ],
    answer: "A"
  },
  {
    id: 7,
    question: "The device that converts digital signals from a computer into analog signals for transmission over telephone lines, and back again, is called a:",
    options: ["A. Switch", "B. Hub", "C. Modem", "D. Repeater"],
    answer: "C"
  },
  {
    id: 8,
    question: "Which of the following is NOT an operating system?",
    options: ["A. Linux", "B. Windows 11", "C. macOS", "D. MS Access"],
    answer: "D"
  },
  {
    id: 9,
    question: "What is the decimal equivalent of the hexadecimal number A3?",
    options: ["A. 163", "B. 173", "C. 153", "D. 143"],
    answer: "A"
  },
  {
    id: 10,
    question: "\"Phishing\" refers to:",
    options: [
      "A. A hardware failure in the hard disk",
      "B. A fraudulent attempt to obtain sensitive information by pretending to be a trustworthy entity",
      "C. A technique for compressing large files",
      "D. Backing up data to cloud storage"
    ],
    answer: "B"
  },
  {
    id: 11,
    question: "In a relational database, a column of a table is called a(n):",
    options: ["A. Tuple", "B. Attribute", "C. Record", "D. Relation"],
    answer: "B"
  },
  {
    id: 12,
    question: "One kilobyte (KB) is equal to:",
    options: ["A. 1000 bits", "B. 1024 bits", "C. 8 bytes", "D. 1024 bytes"],
    answer: "D"
  },
  {
    id: 13,
    question: "An online retailer selling products directly to individual customers follows which e-commerce model?",
    options: ["A. B2B", "B. C2C", "C. B2C", "D. G2B"],
    answer: "C"
  },
  {
    id: 14,
    question: "What is the default file extension of a presentation saved in MS PowerPoint 2007 and later versions?",
    options: ["A. .docx", "B. .pptx", "C. .xlsx", "D. .accdb"],
    answer: "B"
  },
  {
    id: 15,
    question: "Which of the following is an output device?",
    options: ["A. Keyboard", "B. Mouse", "C. Scanner", "D. Plotter"],
    answer: "D"
  },
  {
    id: 16,
    question: "In MS Excel, which cell reference remains unchanged when a formula is copied to another cell?",
    options: ["A. $A$1", "B. A1", "C. A$1", "D. $A1"],
    answer: "A"
  },
  {
    id: 17,
    question: "The primary function of a firewall is to:",
    options: [
      "A. Increase the speed of the internet connection",
      "B. Remove viruses from infected files",
      "C. Cool the processor of the computer",
      "D. Monitor and control incoming and outgoing network traffic based on security rules"
    ],
    answer: "D"
  },
  {
    id: 18,
    question: "Which of the following is an example of cloud-based file storage service?",
    options: ["A. MS Paint", "B. Google Drive", "C. Notepad", "D. Command Prompt"],
    answer: "B"
  },
  {
    id: 19,
    question: "A computer network that spans an entire city is known as a:",
    options: ["A. LAN", "B. PAN", "C. MAN", "D. WAN"],
    answer: "C"
  },
  {
    id: 20,
    question: "Which of the following is an example of system software?",
    options: ["A. Device driver", "B. MS Word", "C. Tally ERP", "D. Adobe Photoshop"],
    answer: "A"
  }

];

export default pgcetmbaComputerAwareness;
